import React from 'react';
import Button from '@mui/material/Button';
import 'react-toastify/dist/ReactToastify.css';
import useStyles from '../styles';
import { PLAYLIST_MODES } from '../../../../../../../core/constants';
import { Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import { usePageLevelVideoConfigContext } from '../../../../../../../Contexts/PageLevelVideoConfigContext';

const CreateConfig = () => {
	const classes = useStyles();
	const { setPlaylistConfigMode, setPlaylistConfigNotFound } = usePageLevelVideoConfigContext();

	const handleCreateConfig = () => {
		setPlaylistConfigNotFound(false);
		setPlaylistConfigMode(PLAYLIST_MODES.SITE_LEVEL_CREATE_PAGE_VIDEOS);
	};

	return (
		<Paper className={classes.containerWrapper}>
			<Typography className={classes.heading} fontWeight={600} variant="h3">
				Cant find config
			</Typography>
			<Button variant="outlined" size="large" onClick={() => handleCreateConfig()}>
				Create Config
			</Button>
		</Paper>
	);
};

export default CreateConfig;
